import dayjs from "dayjs";
import React from "react";
import { useTranslation } from "react-i18next";
import config from "shared/config";
import { ACCOUNTS_PAYABLE_QUEUE_TYPES } from "../constants";

export function useAccountsPayableRequestsQueueColumns(queue) {
  const { t, i18n } = useTranslation("AccountsPayable");

  const columns = React.useMemo(() => {
    const sharedColumns = [
      {
        accessorKey: "number",
        header: t("queue.columns.request_number"),
        filterVariant: "text",
        enableClickToCopy: true,
      },
      {
        accessorKey: "type.label",
        id: "type",
        header: t("queue.columns.request_type"),
        filterVariant: "select",
        enableClickToCopy: true,
      },
      {
        accessorKey: "user",
        header: t("queue.columns.user"),
        filterVariant: "text",
        enableClickToCopy: true,
      },
      {
        accessorFn: (originalRow) => dayjs(originalRow.date_submitted).toDate(), // convert to date for sorting and filtering
        id: "date_submitted",
        filterVariant: "datetime-range",
        header: t("queue.columns.date_submitted"),
        enableClickToCopy: true,
        Cell: ({ cell }) =>
          dayjs(cell.getValue()).format(config.DATE_TIME_FORMAT), // convert back to string for display
      },
      {
        accessorFn: (originalRow) => dayjs(originalRow.date_appeared).toDate(), // convert to date for sorting and filtering
        id: "date_appeared",
        header: t("queue.columns.date_appeared"),
        filterVariant: "datetime-range",
        enableClickToCopy: true,
        Cell: ({ cell }) =>
          dayjs(cell.getValue()).format(config.DATE_TIME_FORMAT), // convert back to string for display
      },
    ];

    const statusColumn = {
      accessorKey: "status.label",
      id: "status",
      header: t("queue.columns.status"),
      filterVariant: "select",
      enableClickToCopy: true,
    };

    const onHoldByColumn = {
      accessorKey: "holded_by",
      header: t("queue.columns.held_by"),
      filterVariant: "text",
      enableClickToCopy: true,
    };

    if (queue === ACCOUNTS_PAYABLE_QUEUE_TYPES.HISTORICAL) {
      return sharedColumns.toSpliced(2, 0, statusColumn);
    } else if (queue === ACCOUNTS_PAYABLE_QUEUE_TYPES.ON_HOLD) {
      return sharedColumns.toSpliced(2, 0, onHoldByColumn);
    } else return sharedColumns;
  }, [i18n.language, queue]);

  return columns;
}
